// extracted by mini-css-extract-plugin
export default {"SearchPage":"SearchPage_SearchPage__ZfKMr","SearchBar":"SearchPage_SearchBar__wvrHp","SearchLoader":"SearchPage_SearchLoader__yHClE"};